import { useState, useEffect } from 'react';

function usePolicyPopup() {
	const [isPopup, setIsPopup] = useState(false);

	useEffect(() => {
		if (window.opener) {
			setIsPopup(true);
		}
	}, []);

	return { isPopup };
}

export default usePolicyPopup;
